define('drops/helper/helper',[
    'jquery',
    'lq/drop',
    'lq/style',
    'lq',
    'lq/util',
    'lq/point'
], function ($, Drop, Style, lq, util, Point) {
    'use strict';

    var defaults = {
        data: {
            showNavigationAtTop: false,
            showNavigationAtBottom: true,
            pageSize: 10,
            text: 'Helper content',
            opacity: 100,
            popupPosition: {
                x: 100,
                y: 100
            },
            popupSize: {
                x: 100,
                y: 100
            }
        }
    };
    
    var durationOfAnimation = 150;

    function Helper(options) {
        Drop.call(this, $('<div/>'), defaults, options);
        
        this.data.popupSize = util.convertListOfKeyValuesToObject(this.data.popupSize);
        this.data.popupPosition = util.convertListOfKeyValuesToObject(this.data.popupPosition);
        this.popupIsVisible = false;

        this.$element
            .addClass('hide-on-print boxToBorderSize');

        var self = this;
        this.$icon = $('<div />')
            .css({
                cursor: 'pointer',
                width: '100%',
                height: '100%',
                backgroundSize: '100% 100%'
            })
            .attr('title', this.data.title)
            .attr('tabindex', this.data.tabIndex)
            .on('click', function (e) {
                self.togglePopup();
            })
            .appendTo(this.$element);

        this.$popup = $('<div />')
            .hide()
	        .addClass('boxToBorderSize') // styling is applied to the $popup instead of $element
            .width(this.data.popupSize.x)
            .height(this.data.popupSize.y)
            .css({
                position: 'absolute',
                top: this.data.popupPosition.y + 'px',
                left: this.data.popupPosition.x + 'px',
                overflowX: 'hidden',
                whiteSpace: 'pre-wrap',
                zIndex: 6001
            })
            .appendTo($('body'));
        
        Style.renderStyles(this, null, this.$popup);
        
        this.originalWidth = this.$popup.width();
        this.originalHeight = this.$popup.height();
        this.setValue({ value: this.data.text });
    };

    Drop.extend(Helper, Drop);

    Helper.typeName = 'Helper';

    Helper.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.setIcon(this.data.physicalFile);
        this.setOpacity(this.data.opacity);
        this.applyPosition();
    };

    Helper.prototype.setIcon = function (physicalFile) {
        var path = physicalFile ? lq.getTenantUploads(physicalFile) : null;
        if(path)
            this.$icon.css('background-image', 'url(' + path + ')');
    };

    Helper.prototype.postRender = function () {
        var self = this;
        this.subscribeEventHandler($(document), 'click', function (e) {
            if (e.target !== self.$icon.get(0) && self.popupIsVisible)
                self.closePopup();
        });
    };

    Helper.prototype.convertToHtmlContent = function (text) {
        return text
            .split('  ')
            .join(' &nbsp;')
            .split('/r/n')
            .join('&nbsp;')
            .replace(/(\r\n|\n|\r)/gm, '<br />');
    };

    Helper.prototype.getStartAndEndPositionForOpeningThePopup = function () {
        var diff = new Point()
            .fromPositionXAndY(this.data.position)
            .subtract(new Point(this.$icon.offset().left, this.$icon.offset().top));
        var corrPopupPosition = new Point()
            .fromPositionXAndY(this.data.popupPosition)
            .subtract(diff);
        return {
            start: {
                top: this.$icon.offset().top + this.data.size.y / 2,
                left: this.$icon.offset().left + this.data.size.x / 2,
                width: 0,
                height: 0
            },
            end: {
                top: corrPopupPosition.y,
                left: corrPopupPosition.x,
                width: this.data.popupSize.x,
                height: this.data.popupSize.y
            }
        };
    };

    Helper.prototype.getEndPositionForClosingThePopup = function () {
        return {
            top: this.$icon.offset().top + this.data.size.y / 2,
            left: this.$icon.offset().left + this.data.size.x / 2,
            width: 0,
            height: 0
        };
    };

    Helper.prototype.togglePopup = function () {
        if (this.popupIsVisible)
            this.closePopup();
        else
            this.openPopup();
    };

    Helper.prototype.closePopup = function () {
        this.popupIsVisible = false;

        var target = this.getEndPositionForClosingThePopup();

        var self = this;
        this.$popup
            .stop()
            .animate(target, durationOfAnimation, function () {
                self.$popup
                    .hide()
                    .css({ width: self.originalWidth, height: self.originalHeight });
            });
    };

    Helper.prototype.openPopup = function () {
        this.popupIsVisible = true;

        var opening = this.getStartAndEndPositionForOpeningThePopup();
        this.$popup
            .stop()
            .css(opening.start)
            .show()
            .animate(opening.end, durationOfAnimation);
    };

    Helper.prototype.hide = function () {
        Drop.prototype.hide.call(this);

        if (this.popupIsVisible)
            this.closePopup();
    };

    Helper.prototype.clearValue = function () {
        this.setValue({ value: null });
    };

    Helper.prototype.setValue = function (update) {
        if(this.popupIsVisible)
            this.closePopup();

        if (!update.value) {
            this.$icon.hide();
            this.$popup.html('');
        } else {
            var htmlContent = this.convertToHtmlContent(update.value);
            this.$popup.html(htmlContent);
            this.$icon.show();
        }
    };

    Helper.prototype.getValue = function () {
        return null;
    };

    Helper.prototype.setOpacity = function (opacity) {
        this.$icon.css({ opacity: (opacity || 100) / 100 });
    };

    Helper.prototype.unsubscribeEventHandlers = function () {
        this.$popup.remove();
    };

    return Helper;
});
